import {Game} from "../game";
import {Board} from "../board";
import {Rock} from "../chessParts/rock";
import {Knight} from "../chessParts/knight";
import {Bishop} from "../chessParts/bishop";
import {Queen} from "../chessParts/queen";
import {King} from "../chessParts/king";
import {Pawn} from "../chessParts/pawn";
import {Settings} from "../settings";

export function initGame() {
    const board = new Board();
    board.scaleX = 8;
    board.scaleY = 8;
    board.players = ['white', 'black'];
    board.currentPlayer = 'white';
    board.chessPieces = [
        part(new Rock(), 0, 0, 'white'),
        part(new Knight(), 1, 0, 'white'),
        part(new Bishop(), 2, 0, 'white'),
        part(new Queen(), 3, 0, 'white'),
        part(new King(), 4, 0, 'white'),
        part(new Bishop(), 5, 0, 'white'),
        part(new Knight(), 6, 0, 'white'),
        part(new Rock(), 7, 0, 'white'),
        part(new Pawn(), 0, 1, 'white'),
        part(new Pawn(), 1, 1, 'white'),
        part(new Pawn(), 2, 1, 'white'),
        part(new Pawn(), 3, 1, 'white'),
        part(new Pawn(), 4, 1, 'white'),
        part(new Pawn(), 5, 1, 'white'),
        part(new Pawn(), 6, 1, 'white'),
        part(new Pawn(), 7, 1, 'white'),

        part(new Rock(), 0, 7, 'black'),
        part(new Knight(), 1, 7, 'black'),
        part(new Bishop(), 2, 7, 'black'),
        part(new Queen(), 3, 7, 'black'),
        part(new King(), 4, 7, 'black'),
        part(new Bishop(), 5, 7, 'black'),
        part(new Knight(), 6, 7, 'black'),
        part(new Rock(), 7, 7, 'black'),
        part(new Pawn(), 0, 6, 'black'),
        part(new Pawn(), 1, 6, 'black'),
        part(new Pawn(), 2, 6, 'black'),
        part(new Pawn(), 3, 6, 'black'),
        part(new Pawn(), 4, 6, 'black'),
        part(new Pawn(), 5, 6, 'black'),
        part(new Pawn(), 6, 6, 'black'),
        part(new Pawn(), 7, 6, 'black')
    ];
    board.initHistory();

    const game = new Game();
    game.board = board;
    game.settings = new Settings();
    game.settings.rotateBoard = true;
    game.settings.rotateTop = true;
    return game;
}

function part(chessPiece, posX, posY, player) {
    chessPiece.posX = posX;
    chessPiece.posY = posY;
    chessPiece.player = player;
    if (player === 'black') {
        chessPiece.direction = [0, -1];
        if (chessPiece.name === 'pawn') {
            chessPiece.initialLine = 6;
        }
    } else {
        chessPiece.direction = [0, 1];
        if (chessPiece.name === 'pawn') {
            chessPiece.initialLine = 1;
        }
    }
    if (chessPiece.name === 'king') {
        chessPiece.main = true;
    }
    if (chessPiece.name === 'rock') {
        chessPiece.castle = true;
    }
    chessPiece.isInitialPos = true;

    return chessPiece;
}